import { Injectable } from '@angular/core';
import { EMPTY, Observable, Subject, catchError } from 'rxjs';

export type CBusEventType = 'order' | 'payment';
export type CBusEventActionType = 'add' | 'update' | 'remove' | 'reset';

export type CBusEventContext = `${CBusEventType}-${CBusEventActionType}`;
export type CBusEvent = {
  body?: any;
  context: CBusEventContext;
};

@Injectable({
  providedIn: 'root',
})
export class ComponentBusService {
  private _eventsSubject$ = new Subject<CBusEvent>();

  public get events$(): Observable<CBusEvent> {
    return this._eventsSubject$.pipe(catchError(() => EMPTY));
  }

  publish(context: CBusEventContext, body?: any) {
    this._eventsSubject$.next({ context, body });
  }
}
